import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit';
import { ActionReducerMapBuilder } from '@reduxjs/toolkit/dist/mapBuilders';
import { checkIfAuthenticated, login, logout } from '../api/auth-api';

const initAuth = createAsyncThunk('auth/init', checkIfAuthenticated);
const loginUser = createAsyncThunk('auth/login', login);
const logoutUser = createAsyncThunk('auth/logout', logout);

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    error: null,
    status: 'idle',
  },
  // Todo: How to simplify extra reducers?
  extraReducers: (builder: ActionReducerMapBuilder<any>) => {
    builder.addCase(initAuth.fulfilled, (state, action) => {
      state.user = action.payload;
      state.status = 'success';
    });
    builder.addCase(initAuth.rejected, (state) => {
      state.status = 'success';
    });

    builder.addCase(loginUser.pending, (state) => {
      state.status = 'pending';
    });
    builder.addCase(loginUser.fulfilled, (state, action) => {
      state.user = action.payload;
      state.status = 'success';
    });
    builder.addCase(loginUser.rejected, (state, action) => {
      state.error = action.error;
      state.status = 'error';
    });

    builder.addCase(logoutUser.pending, (state) => {
      state.status = 'pending';
    });
    builder.addCase(logoutUser.fulfilled, (state) => {
      state.user = null;
      state.status = 'success';
    });
    builder.addCase(logoutUser.rejected, (state, action) => {
      // Todo: If logout fails user will be logged in on page refresh. Should we set user to null?
      state.user = null;
      state.status = 'error';
      state.error = action.error;
    });
  },
} as any);

const selectAuth = (state: any) => state.auth;

const selectAuthUser = createSelector(selectAuth, (auth) => auth.user);

const authReducer = authSlice.reducer;

export { authReducer, initAuth, loginUser, logoutUser, selectAuthUser, selectAuth };






